import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Persistent simulation disclaimer shown on demonstration-tagged records and
 * across the demo environment. Stays visible but not overpowering.
 */
export function SimulationDisclaimer({ variant = 'inline', compact = false }) {
  if (variant === 'ribbon') {
    return (
      <div
        data-testid="simulation-ribbon"
        className="w-full bg-amber-500/10 border-b border-amber-500/30 text-amber-800 dark:text-amber-200 py-1.5 px-4 text-[11px] flex items-center justify-center gap-2"
      >
        <AlertTriangle size={12} className="shrink-0" />
        <span>
          <span className="font-semibold">Demonstration environment</span> · All alerts, incidents and evidence shown are simulated scenarios created for product demonstration and do not represent actual events at the displayed locations.
        </span>
      </div>
    );
  }
  if (compact) {
    return (
      <span data-testid="simulation-chip" className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest rounded px-1.5 py-0.5 bg-amber-500/15 text-amber-700 dark:text-amber-300 border border-amber-500/30">
        <AlertTriangle size={10} />
        Simulated
      </span>
    );
  }
  return (
    <div
      data-testid="simulation-disclaimer"
      className="rounded-md border border-amber-500/40 bg-amber-500/10 text-amber-900 dark:text-amber-100 px-3 py-2 text-xs flex items-start gap-2"
    >
      <AlertTriangle size={14} className="shrink-0 mt-0.5" />
      <div>
        <span className="font-semibold">Simulated scenario.</span> This record has been created for product demonstration. It does not represent an actual incident at the displayed location.
      </div>
    </div>
  );
}
